exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".index,body{background:#fff}.right_icon{float:right;height:50px;padding-right:8px}.page_border{padding:4px}.demo-spin-icon-load{animation:ani-demo-spin 1s linear infinite}@keyframes ani-demo-spin{0%{transform:rotate(0deg)}50%{transform:rotate(180deg)}to{transform:rotate(1turn)}}.demo-spin-col{height:100px;position:relative;border:1px solid #eee}.mint-step--horizontal:last-child{right:0!important}.mint-step--horizontal:last-child .mint-step__circle-container{left:0!important}.mint-step{width:25%!important;-ms-flex:none!important;flex:none!important}.mint-step--horizontal .mint-step__title,.mint-step--horizontal:first-child .mint-step__title{transform:translate3d(-30%,0,0)!important}.mint-step--horizontal:last-child .mint-step__title{transform:translate3d(-20%,0,0)!important}.mint-steps--horizontal .mint-steps__items{padding-left:30px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-1bf04494!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/index/index.vue
// module id = 157
// module chunks = 0